import NProgress from 'nprogress';

export default NProgress;



// WEBPACK FOOTER //
// ./components/nprogress/index.js